export default "__VITE_ASSET__DIVELpto__"